import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import TONHero from "./TONHero";
import TONBlockchain from "./TONBlockchain";
import TONDApp from "./TONDApp";
import BenefitsOFTON from "./BenefitsOFTON";

function TON() {
  return (
    <>
      <Header />
      <TONHero />
      <TONBlockchain />
      <TONDApp />
      <BenefitsOFTON />
      <Footer />
    </>
  );
}

export default TON;
